import * as v from 'valibot'
import type { imageTypes } from 'src/features/UserDecoration/schema/decoration'
import { DecorationAvatarFrameDataSchema } from 'src/features/UserDecoration/schema/decoration'
import type { DecorationItem } from 'src/services/orpc/decoration'
import { cn } from 'src/utils/cx'

export type DecorationSize = (typeof imageTypes)[number] | 'original'

export type AvatarFrameProps = StyleProps & {
  decoration?: DecorationItem
  decorationSize?: DecorationSize
}

export default function AvatarFrame({
  className,
  style,
  decoration,
  decorationSize = 'original',
}: AvatarFrameProps) {
  const data = v.safeParse(DecorationAvatarFrameDataSchema, decoration?.data)
  if (!data.success) return null
  const assetUrl = data.output?.mediaAsset?.original || data.output?.assetUrl
  const variants = data.output?.mediaAsset?.variants

  let srcset = ''
  let src = assetUrl

  if (variants) {
    if (decorationSize === 'small') {
      // Small: small (default), medium (3x)
      src = variants.small?.url || assetUrl
      srcset = variants.medium
        ? `${variants.small?.url || assetUrl}, ${variants.medium.url} 3x`
        : ''
    } else if (decorationSize === 'medium') {
      // Medium: medium (default), large (2x)
      src = variants.medium?.url || assetUrl
      srcset = variants.large
        ? `${variants.medium?.url || assetUrl}, ${variants.large.url} 2x`
        : ''
    } else if (decorationSize === 'large') {
      // Large: large (default), original (2x)
      src = variants.large?.url || assetUrl
      srcset = `${variants.large?.url || assetUrl}, ${assetUrl} 2x`
    }
  }

  return (
    <img
      src={src}
      srcSet={srcset || undefined}
      alt="avatar-frame"
      className={cn('absolute object-fill pointer-events-none', className)}
      style={style}
    />
  )
}
